import { AttachmentDestination } from '@/services';
import { ResourceActivityResourceType, VersionedResourceType } from '@/types';

const resourceTypeByDestination = {
    investment: 'investments',
    list: 'lists',
    task: 'tasks',
} as const satisfies Record<AttachmentDestination['resourceType'], VersionedResourceType>;

export const resourceTypeForAttachmentDestination = (
    destination: AttachmentDestination,
): ResourceActivityResourceType => resourceTypeByDestination[destination.resourceType];

export const historyResourceTypeForAttachmentDestination = (
    destination: AttachmentDestination,
): VersionedResourceType => resourceTypeByDestination[destination.resourceType];
